/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Text,
  Space,
  Conditional,
  Embed,
} from '@cashfree-intl/coherent';

import { CURRENCY_SYMBOL } from 'utils/constants';
import { numberWithCommas } from 'utils/common';
import pitchbg from '../../../images/instant-settlements-pitch-page-bg.svg';
import { ACTIVE } from '../constants';
import CustomIcon from '../../../components/CustomIcons';

const list = [
  'Get early access to your funds and scale your business to new heights.',
  'Uninterrupted cashflow for a nominal fee.',
  'Payments settled automatically - starting every 15 minutes.',
  'Select settlement cycle according to your business needs.',
];

const PITCH_VIDEO_LINK = 'https://www.youtube.com/embed/ALRNvRBmdz8';

const PitchPage = ({
  showFAQModal,
  onRequestActivation,
  config,
  onDemandStatus,
  autoActivationEligible,
}) => {
  const styleProps = {
    backgroundImage: `url(${pitchbg})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    borderRadius: '0.75rem',
  };

  return (
    <div className="p-4 mb-4 instant-settlements-pitch-page" style={styleProps}>
      <Space alignItems="center" justifyContent="space-between">
        <Text variant="h28" className="mb-1 pitch-title" color="white">
          Get your Settlements Instantly!
        </Text>
        {config && config.workingDayLimitInLakhs && (
          <Conditional if={onDemandStatus !== ACTIVE}>
            <Space alignItems="center">
              <Space alignItems="center">
                <CustomIcon componentName="GREEN_TICK" />
                <Text variant="b12" color="white" className="ml-1">
                  Pre-approved daily limit of {CURRENCY_SYMBOL.INR}{' '}
                  {numberWithCommas(config.workingDayLimitInLakhs * 100000)}
                </Text>
              </Space>
              <div className="horizontal-divider mx-1 my-0" />
              <Space alignItems="center">
                <CustomIcon componentName="GREEN_TICK" />
                <Text variant="b12" color="white" className="ml-1">
                  Get maximum daily limit after approval
                </Text>
              </Space>
            </Space>
          </Conditional>
        )}
      </Space>
      <Text variant="h16" className="mb-2" color="white">
        Watch the video to know more.
      </Text>
      <div className="instant-settlements-pitch-content">
        <Embed
          className="pitch-banner-embed"
          active
          iframe={{
            allowFullScreen: true,
          }}
          url={PITCH_VIDEO_LINK}
        />
        <div className="pitch-page-description">
          <div className="pitch-page-text-content">
            {list.map(item => (
              <Space alignItems="center" gap={1} className="mb-2">
                <img
                  src="https://cashfreelogo.cashfree.com/website/pg/od-settlements-assets/stars-group.svg"
                  alt="stars-group"
                />
                <Text variant="h16" color="white">
                  {item}
                </Text>
              </Space>
            ))}
          </div>
          <Button
            type="button"
            default
            onClick={onRequestActivation}
            className="activate-instantly-cta"
            data-event-name="Primary_Button_ActivateInstantly"
          >
            <span className="text-primary">
              {autoActivationEligible
                ? 'Activate Instantly'
                : 'Request Activation'}
            </span>
          </Button>
        </div>
      </div>
      <div className="text-right">
        <a
          className="medium-text w-600 text-white"
          onClick={showFAQModal}
          data-event-name="Link_HaveAnyQuestions"
        >
          Have any questions?
        </a>
      </div>
    </div>
  );
};

PitchPage.propTypes = {
  showFAQModal: PropTypes.func.isRequired,
  onRequestActivation: PropTypes.func.isRequired,
  onDemandStatus: PropTypes.any.isRequired,
  config: PropTypes.any,
  autoActivationEligible: PropTypes.bool.isRequired,
};

export default PitchPage;
